import { IconButton, InputAdornment } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import Iconify from '../../../../../reusable-components/iconify/Iconify';
import { formStyle } from '../../contractStyles';
import { validateDate } from './FormTextField-components/ValidateFunctions';

FormDatePickerField.propTypes = {
    fieldName: PropTypes.string,
    focusedField: PropTypes.string,
    setFocusedField: PropTypes.func,
    validation: PropTypes.shape({ required: PropTypes.bool, minDate: PropTypes.instanceOf(Date), maxDate: PropTypes.instanceOf(Date) }),
    disabled: PropTypes.bool,
};

export default function FormDatePickerField({
    fieldName,
    focusedField,
    setFocusedField,
    validation,
    disabled = false
}) {
    const { control } = useFormContext();
    const [open, setOpen] = useState(false);

    return (
        <Controller
            name={fieldName}
            control={control}
            rules={{
                required: validation?.required ? 'This field is required' : undefined,
                validate: (value) => validateDate(value, validation?.required, validation?.minDate, validation?.maxDate),
            }}
            render={({ field, fieldState }) => (
                <DatePicker
                    value={field.value ? dayjs(field.value).toDate() : null}
                    onChange={(newValue) => {
                        const normalized = newValue ? dayjs(newValue).format('YYYY-MM-DD') : null;
                        field.onChange(normalized);
                    }}
                    maxDate={validation?.maxDate && dayjs(validation?.maxDate).isValid() ? dayjs(validation.maxDate).toDate() : undefined}
                    minDate={validation?.minDate && dayjs(validation?.minDate).isValid() ? dayjs(validation.minDate).toDate() : undefined}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                        }
                    }}
                    disabled={disabled}
                    open={open}
                    onOpen={() => setOpen(true)}
                    onClose={() => setOpen(false)}
                    slotProps={{
                        textField: {
                            key: field.id,
                            fullWidth: true,
                            placeholder: !disabled ? 'MM/DD/YYYY' : '',
                            size: 'small',
                            error: !!fieldState.error,
                            helperText: fieldState.error?.message,
                            onFocus: () => setFocusedField(fieldName),
                            onBlur: () => setFocusedField(null),
                            onClick: () => setOpen(true),
                            sx: formStyle,
                            InputProps: {
                                endAdornment: (
                                    <>
                                        {!disabled && (
                                            <InputAdornment position="end">
                                                <IconButton size="small" edge="end" tabIndex={-1} onClick={() => setOpen(true)}>
                                                    <Iconify icon="eva:calendar-outline" />
                                                </IconButton>
                                            </InputAdornment>
                                        )}

                                        {field.value && focusedField === fieldName && (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    size="small"
                                                    edge="end"
                                                    tabIndex={-1}
                                                    onMouseDown={(e) => e.preventDefault()}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        setOpen(false);
                                                        field.onChange(null);
                                                    }}
                                                >
                                                    <Iconify icon="eva:close-outline" />
                                                </IconButton>
                                            </InputAdornment>
                                        )}
                                    </>
                                ),
                            },
                        },
                    }}
                />
            )}
        />
    );
}
